import {getAbsoluteUrl} from "../../utils/urlUtill";
import {IHttpPromise} from "angular";
import {ChartData} from "chart.js";
import {OpportunityStatistics} from "../model/OpportunityStatistics";
import {ConversionStatisticsType} from "../model/ConversionStatisticsType";

export class StatisticsService {

    constructor(private $http: angular.IHttpService) {
    }

    getNumberOfCustomers(startDate: string,
                         endDate: string,
                         aggrateOver: number,
                         pockets: any,
                         url: string): IHttpPromise<ChartData> {
        return this.$http.get(
            getAbsoluteUrl(url, {
                startingFrom: startDate,
                endingAt: endDate,
                aggregateOverDays: aggrateOver
            })
        )
    }

    getOpportunitiesStatistics(startDate: string,
                               endDate: string,
                               aggregateOverDays: number): IHttpPromise<OpportunityStatistics[]> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/statistic/opportunities'),
            params: {
                fromDate: startDate,
                toDate: endDate,
                aggregateOverDays: aggregateOverDays
            }
        })
    }

    getOpportunityActionStatistics(startDate: string,
                                   endDate: string,
                                   aggregateOverDays: number): IHttpPromise<OpportunityStatistics[]> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/statistic/opportunity_actions'),
            params: {
                fromDate: startDate,
                toDate: endDate,
                aggregateOverDays: aggregateOverDays
            }
        })
    }


    getConversionsStatistics(startDate: string,
                             endDate: string,
                             aggregateOverDays: number,
                             numberOfPockets: number,
                             type: ConversionStatisticsType): IHttpPromise<ChartData> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/statistics/conversions'),
            params: {
                startingFrom: startDate,
                endingAt: endDate,
                aggregateOverDays: aggregateOverDays,
                numberOfPockets: numberOfPockets,
                type: type
            }
        })
    }

}

export const STATISTICS_SERVICE = ['$http', StatisticsService];
